import React from "react";
import { Bell } from "lucide-react";
import HeroCard from "@/components/shared/HeroCard";

function getGreeting() {
  const h = new Date().getHours();
  if (h >= 5 && h < 12) return "Buenos días";
  if (h >= 12 && h < 19) return "Buenas tardes";
  return "Buenas noches";
}

function DashboardHero({
  firstName,
  district,
  notifCount = 0,
  onNotifClick,
}) {
  return (
    <div className="relative">
      <HeroCard
        title={`${getGreeting()}${firstName ? `, ${firstName}` : ""}`}
        subtitle={
          district?.field_name ? (
            <>
              <span className="block leading-snug">{district.name || "Distrito"}</span>
              <span className="block text-[12px] text-white/55 leading-snug mt-0.5">{district.field_name}</span>
            </>
          ) : (district?.name || "Distrito")
        }
        icon={
          <img
            src="/icons/iasd-icon-clean.png"
            alt="IASD"
            className="h-10 w-10 object-contain brightness-0 invert opacity-80"
          />
        }
        iconContainerClassName="h-10 w-10 sm:h-12 sm:w-12 shrink-0 rounded-full bg-white/[0.07] shadow-[0_0_18px_rgba(255,255,255,0.07)] flex items-center justify-center overflow-hidden"
        gradient="from-[#012e68] via-[#1b4f9c] to-[#0066ff]"
        actions={
          <button
            aria-label="Notificaciones"
            onClick={onNotifClick}
            className="
              relative h-11 w-11 rounded-full
              bg-white/10 border border-white/15
              backdrop-blur-sm
              flex items-center justify-center
              text-white/80
              transition-all duration-200 ease-out
              hover:bg-white/20 hover:text-white
              active:scale-[0.98]
            "
          >
            <Bell size={15} strokeWidth={2} />
            {notifCount > 0 && (
              <span className="
                absolute -top-0.5 -right-0.5
                h-[14px] min-w-[14px] px-0.5
                rounded-full
                bg-amber-400
                border border-white/30
                flex items-center justify-center
              ">
                <span className="text-[7px] font-bold text-white leading-none">
                  {notifCount > 9 ? "9+" : notifCount}
                </span>
              </span>
            )}
          </button>
        }
      />
      {/* atmospheric bridge — hero glow bleeds into the page surface */}
      <div className="pointer-events-none absolute bottom-0 left-1/2 -translate-x-1/2 h-8 w-3/4 bg-[#0066ff]/8 blur-lg" />
    </div>
  );
}

export default React.memo(DashboardHero);
